function leftShiftBase10(value, positions) {
  return value * 10 ** positions;
}
function floorAtPosition(value, position) {
  return leftShiftBase10(
    Math.floor(leftShiftBase10(value, -position)),
    position
  );
}
function strictParseInt(value, radix) {
  return /^[0-9]*$/.test(value) ? Number.parseInt(value, radix) : NaN;
}
export {
  floorAtPosition,
  leftShiftBase10,
  strictParseInt
};
